import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import fileDownload from 'js-file-download';
import { NavLink } from 'react-router';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { detectExt, responseLogWithNotification } from '../../../utils/utils';
import { loadFileByUrl } from '../actions';
import { successNotification } from '../../Notifications/notificationDecorator';

export default function ViewFile(props) {
  const {
    file = {},
    isDownloadAvailable = true,
    title = '',
    handleClose = () => {},
  } = props;
  const viewFile = file.find(e => e.collection_name === 'html');
  const downloadFile = file.find(e => e.collection_name === 'files');
  const dispatch = useDispatch();

  const handleDownload = () => {
    if (!downloadFile) {
      return;
    }
    dispatch(loadFileByUrl(downloadFile?.url))
      .then(data => {
        if (data) {
          fileDownload(data, downloadFile?.file_name);
          successNotification('Скачивание файла', 'Успешно');
        }
      })
      .catch(responseLogWithNotification);
    return false;
  };

  return (
    <Dialog
      onClose={handleClose}
      open
      className={classNames('file-viewer')}
      size="xl"
    >
      <DialogTitle
        header={(
          <div className="page-title d-sm-flex">
            <div className="title-text">{title || 'Просмотр файла'}</div>
          </div>
        )}
      />
      <DialogContent>
        {viewFile && viewFile.url
          ? <iframe title="Просмотр файла" src={viewFile?.url || ''} frameBorder="0" width="100%" height="100%" /> : null}
        {!viewFile || !viewFile.url ? <div className="file-not-found">Файл не найден</div> : null}
      </DialogContent>
      <DialogFooter className="modal-buttons">
        {isDownloadAvailable ? (
          <Button
            variant="secondary"
            className="download-button"
            onClick={handleDownload}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="download" />
            <span className="download-button-text">Скачать</span>
          </Button>
        ) : null}
      </DialogFooter>
    </Dialog>
  );
}
